import Checkers from "../../../../../../helpers/class/Checkers";

interface MediaSectionInterface {
    threesixtyTour?: string
    factsheetDocument?: string
}

export const MediaSection = ( {factsheetDocument, threesixtyTour} : MediaSectionInterface ) => {
    return (
        <>
            <div id="pro_detail_factsheets" className="row full-width no-margin pb-5">
                <div className="row">
                    {
                        Checkers.isValidString(threesixtyTour) && threesixtyTour!='0' ?
                            <>
                                <div className="col-sm-6">
                                    <a href={threesixtyTour} target="_blank" rel="noreferrer" className="text-master">
                                        <div className="">
                                            <div
                                                className="profile-img-wrapper m-t-5 d-flex justify-content-center align-items-center b-grey b-a"
                                                style={{width: '55px', height: '55px'}}>
                                                <i className="fa fa-regular fa-panorama fa-2x hint-text"></i>
                                                <div className="chat-status available"></div>
                                            </div>
                                            <div className="inline m-l-10">
                                                <p className="hint-text m-t-10"><strong>360<sup>o</sup> Virtual Tour</strong>
                                                    <br /><span className="btn-link">Walk through the property</span></p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </>
                            :
                            <>
                            </>
                    }
                    {
                        Checkers.isValidString(factsheetDocument) ?
                            <>
                                <div className="col-sm-6">
                                    <a href={factsheetDocument} target="_blank" rel="noreferrer" className="text-master">
                                        <div className="">
                                            <div
                                                className="profile-img-wrapper m-t-5 d-flex justify-content-center align-items-center b-grey b-a"
                                                style={{width: '55px', height: '55px'}}>
                                                <i className="fa fa-duotone fa-file-pdf fa-2x hint-text"></i>
                                                <div className="chat-status available"></div>
                                            </div>
                                            <div className="inline m-l-10">
                                                <p className="hint-text m-t-10"><strong>PDF Fact sheet</strong> <br/><span
                                                    className="btn-link">Download the property PDF</span></p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </>
                            :
                            <>
                            </>
                    }

                </div>
            </div>
        </>
    )
}